module.exports = __webpack_public_path__ + "img/logo-lanapolis-desktop.8057f155.svg";